import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Subscription, take, finalize } from 'rxjs';
import { AfericaoAmpliacaoService } from 'src/app/modules/services/afericao-ampliacao/afericao-ampliacao.service';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { PageStateService } from 'src/app/modules/services/page-state/page-state.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { UserService } from 'src/app/modules/services/user/user.service';
import { AnalyzeDetailComponent } from 'src/app/modules/shared/modals/analyze-detail/analyze-detail.component';
import { ModalFiltersComponent } from 'src/app/modules/shared/modals/modal-filters/modal-filters.component';
import { AlertComponent } from '../../alert/alert.component';
import { LoadingService } from '../../loading/loading.service';

@Component({
  selector: 'app-afericao-ampliacao',
  templateUrl: './afericao-ampliacao.component.html',
  styleUrls: ['./afericao-ampliacao.component.scss']
})
export class AfericaoAmpliacaoComponent implements OnInit, OnDestroy {
  buttonInclusaoDisabled: boolean = false;
  buttonEdicaoDisabled: boolean = false;
  buttonExclusaoDisabled: boolean = false;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };
  formAfericaoAmpliacao!: FormGroup;
  columnConfig = [
    { columnDef: 'contrato', header: 'Contrato', property: 'contrato.contractNumber', customTd: true },
    { columnDef: 'codigo', header: 'Intervenção', property: 'codigo' },
    { columnDef: 'rodovia', header: 'Rodovia', property: 'rodovia' },
    { columnDef: 'municipios', header: 'Município', property: 'municipios', customTd: true },
    { columnDef: 'kmInicial', header: 'KM Inicial', property: 'kmInicial' },
    { columnDef: 'kmFinal', header: 'KM Final', property: 'kmFinal' },
    { columnDef: 'kmExtensao', header: 'Extensão', property: 'kmExtensao' },
    { columnDef: 'anoConclusao', header: 'Ano Conclusão', property: 'anoConclusao' },
    { columnDef: 'prazoVigenteFinal', header: 'Prazo Final Vigente', property: 'prazoVigenteFinal', customTd: true },
    { columnDef: 'dataAfericao', header: 'Aferição/Ciência', property: 'dataAfericao', customTd: true },
    { columnDef: 'statusAtual', header: 'Status', property: 'statusAtual', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];
  arrayStatus: any = [
    { label: "Pendente de comprovação", property: "", selected: false },
    { label: "Comprovação enviada", property: "", selected: false },
    { label: "Em análise", property: "", selected: false },
    { label: "Parâmetro atestado", property: "", selected: false },
    { label: "Aguardando complementação das informações", property: "", selected: false },
  ];
  canEdit: boolean = true;
  canDelete: boolean = true;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalPages: number = 1;
  totalElements: number = 0;
  subscriptions: Subscription[] = [];
  criterios: any = [];
  criteriosLabels!: { [key: string]: string; };
  filterData: any;
  screenWidth: number = window.innerWidth;
  filterTextValue: string = '';
  statusFilter: any;
  customFilter: any;
  statusTransition: any;
  idEntidade: any;
  idAmpliacao: any;
  idDocumentoComprovacao: any;
  transicaoId: any;
  statusAtualId: any;
  currentRoute: string = '';
  listConcessoesFilter: [] = [];
  kmInicialInicio: any;
  kmInicialFim: any;
  kmFinalInicio: any;
  kmFinalFim: any;
  anoConclusaoInicio: any;
  anoConclusaoFim: any;
  filtersRange: any = {};
  constructor(
    private afericaoAmpliacaoService: AfericaoAmpliacaoService,
    private pageSizeService: PageSizeService,
    private pageStateService: PageStateService,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    private router: Router,
    public toastService: ToastService,
    private authService: AuthService,
    private userService: UserService,
    private route: ActivatedRoute
  ) {
    this.currentRoute = this.router.url;
    this.formAfericaoAmpliacao = this.fb.group({
      anoConclusao: [null],
      idsMunicipios: [[]],
      rodovia: [''],
      nomeOrigemObra: [''],
      nomeTipoObra: [''],
      sentido: [''],
      segmentoHomogeneo: [''],
      kmInicialInicio: [''],
      kmInicialFim: [''],
      kmFinalInicio: [''],
      kmFinalFim: [''],
      kmCampoInicialInicio: [''],
      kmCampoInicialFim: [''],
      kmCampoFinalInicio: [''],
      kmCampoFinalFim: [''],
      naturezaPrazo: [''],
      prazoInicialInicio: [''],
      prazoInicialFim: [''],
      prazoFinalInicio: [''],
      prazoFinalFim: [''],
      prazoVigenteInicialInicio: [''],
      prazoVigenteInicialFim: [''],
      prazoVigenteFinalInicio: [''],
      prazoVigenteFinalFim: [''],
      valorObraInicio: [''],
      valorObraFim: [''],
      valorObraAtualizadoInicio: [''],
      valorObraAtualizadoFim: [''],
      latitudeInicialInicio: [''],
      latitudeInicialFim: [''],
      latitudeFinalInicio: [''],
      latitudeFinalFim: [''],
      longitudeInicialInicio: [''],
      longitudeInicialFim: [''],
      longitudeFinalInicio: [''],
      longitudeFinalFim: [''],
    });
    this.buildCriteriosLabels();
    this.loadUserInfo();
  }

  ngOnInit(): void {
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    const savedPageIndex = this.pageStateService.getPageState(this.router.url);
    if (savedPageIndex) {
      this.pageIndex = savedPageIndex;
    }
    this.getData(this.pageIndex);
    this.getListConcessoes();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.subscriptions.push(
        this.userService.getMenuUsuario(userId).subscribe((response: any) => {
          const functionalities = response.profileUser.permissaoPerfis;
          functionalities.forEach((permission: any) => {
            this.checkFunctionality(permission.funcionalidade);
          });
        })
      );
    }
  }

  checkFunctionality(functionality: any) {
    if (functionality.url === this.currentRoute) {
      this.handleRestrictions(functionality.restricoes);
    }

    if (functionality.subFuncionalidades && functionality.subFuncionalidades.length > 0) {
      functionality.subFuncionalidades.forEach((subFunctionality: any) => {
        this.checkFunctionality(subFunctionality);
      });
    }
  }

  handleRestrictions(restrictions: any[]) {
    restrictions.forEach((restriction: { nome: any; }) => {
      switch (restriction.nome) {
        case 'Inclusão':
          this.buttonInclusaoDisabled = true;
          break;
        case 'Exclusão':
          this.buttonExclusaoDisabled = true;
          break;
        case 'Edição':
          this.buttonEdicaoDisabled = true;
          break;
      }
    });
  }

  private buildCriteriosLabels() {
    this.criteriosLabels = {
      anoConclusao: 'Ano Conclusão',
      idsMunicipios: 'Municípios',
      rodovia: 'Rodovia',
      kmInicialInicio: 'Km inicial - Início',
      kmInicialFim: 'Km inicial - Fim',
      kmFinalInicio: 'Km final - Início',
      kmFinalFim: 'Km final - Fim',
      nomeOrigemObra: 'Origem',
      nomeTipoObra: 'Tipo de obra',
      sentido: 'Sentido',
      segmentoHomogeneo: 'Segmento homogêneo',
      kmCampoInicialInicio: 'Km campo inicial - Início',
      kmCampoInicialFim: 'Km campo inicial - Fim',
      kmCampoFinalInicio: 'Km campo final - Início',
      kmCampoFinalFim: 'Km campo final - Fim',
      naturezaPrazo: 'Natureza do prazo',
      prazoInicialInicio: 'Prazo inicial - Início',
      prazoInicialFim: 'Prazo inicial - Fim',
      prazoFinalInicio: 'Prazo final - Início',
      prazoFinalFim: 'Prazo final - Fim',
      prazoVigenteInicialInicio: 'Prazo vigente inicial - Início',
      prazoVigenteInicialFim: 'Prazo vigente inicial - Fim',
      prazoVigenteFinalInicio: 'Prazo vigente final - Início',
      prazoVigenteFinalFim: 'Prazo vigente final - Fim',
      valorObraInicio: 'Valor da obra - Início',
      valorObraFim: 'Valor da obra - Fim',
      valorObraAtualizadoInicio: 'Valor da obra atualizado - Início',
      valorObraAtualizadoFim: 'Valor da obra atualizado - Fim',
      latitudeInicialInicio: 'Latitude inicial - Início',
      latitudeInicialFim: 'Latitude inicial - Fim',
      latitudeFinalInicio: 'Latitude final - Início',
      latitudeFinalFim: ' Latitude final - Fim',
      longitudeInicialInicio: 'Longitude inicial - Início',
      longitudeInicialFim: 'Longitude inicial - Fim',
      longitudeFinalInicio: 'Longitude final - Início',
      longitudeFinalFim: 'Longitude final - Fim',
    };
  }

  getData(pageIndex: number = 0) {
    this.loadingService.showLoading();
    this.subscriptions.push(
      this.afericaoAmpliacaoService.getAfericaoAmpliacaos(
        this.pageSize,
        pageIndex,
        this.sortState.sortDirection,
        this.sortState.sortProperty,
        this.filterTextValue,
        this.filterData,
        this.statusFilter,
        this.customFilter,
        this.filtersRange
      ).subscribe((resp: any) => {
        this.loadingService.hideLoading();
        const { content, pageSize, totalPages, totalElements, pageNumber } = resp;
        this.dataSource.data = content;
        this.pageSize = pageSize;
        this.totalPages = totalPages;
        this.totalElements = totalElements;
        this.pageIndex = pageNumber;
      })
    );
  }

  getListConcessoes() {
    this.loadingService.showLoading();
    this.subscriptions.push(
      this.afericaoAmpliacaoService.getConcessoes(
      ).subscribe((resp: any) => {
        this.loadingService.hideLoading();
        const newListaConcessoes = resp.content.map((item: any) => item = { label: item.contractName, selected: false })
        this.listConcessoesFilter = newListaConcessoes;
      })
    );
  }

  pageChangeEvent(event: PageEvent) {
    if (this.pageSize !== event.pageSize) {
      this.pageSize = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      return this.getData(0);
    }
    if (this.pageIndex !== event.pageIndex) {
      this.pageStateService.setPageState(this.router.url, event.pageIndex);
      return this.getData(event.pageIndex);
    }
  }

  onSortChange(sortProperty: any): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }
    this.getData();
  }

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  redirectToDetailPage(id: number): void {
    this.router.navigate([`detail-afericao-ampliacao/${id}`]);
  }

  openActivateDialog(id: number): void {
    // Lógica para ativar a ampliação

  }

  openInactivateDialog(id: number): void {
    // Lógica para inativar a ampliação

  }

  applyFilter(filterValue: string) {
    this.filterTextValue = filterValue;
    this.getData();
  }

  openModalFilters(popover?: any) {
    let props;
    if (this.filterData) {
      props = this.filterData;
    } else {
      props = this.generatePropsFromForm(this.formAfericaoAmpliacao);
    }

    const data = {
      type: 'afericaoAmpliacao',
      propsAfericaoAmpliacaos: props
    };

    const dialogRef = this.dialog.open(ModalFiltersComponent, {
      panelClass: ['ampliacao-panel'],
      data,
    });

    dialogRef.afterClosed().subscribe({
      next: (data: any) => {
        if (data) {
          this.filterData = data;
          if (data.value.anoConclusao) this.processRange(data.value.anoConclusao, 'anoConclusaoInicio', 'anoConclusaoFim');
          if (!data.value.anoConclusao) {
            this.anoConclusaoInicio = null;
            this.anoConclusaoFim = null;
          }
          this.filtersRange = {
            kmInicialInicio: this.kmInicialInicio,
            kmInicialFim: this.kmInicialFim,
            kmFinalInicio: this.kmFinalInicio,
            kmFinalFim: this.kmFinalFim,
            anoConclusaoInicio: this.anoConclusaoInicio,
            anoConclusaoFim: this.anoConclusaoFim,
          }

          this.criterios = this.getCriterios(data);
          this.getData();
        }
      }
    });
  }

  private generatePropsFromForm(form: FormGroup): any {
    const props: any = {};
    Object.keys(form.controls).forEach((controlName: string) => {
      const control = form.get(controlName);
      if (control && control.value !== null && control.value !== undefined && control.value !== '') {
        props[controlName] = control.value;
      }
    });
    return props;
  }

  getCriterios(data: any) {
    const criterios = [];
    const props: any = this.generatePropsFromForm(data);

    for (const prop in props) {
      const value = props[prop];

      // Verifica se o valor é um array e, se for, se tem elementos
      const isArrayEmpty = Array.isArray(value) && value.length === 0;

      // Adiciona a propriedade se o valor não for nulo/indefinido/vazio e não for um array vazio
      if (value !== null && value !== undefined && value !== '' && !isArrayEmpty) {
        criterios.push(prop);
      }
    }

    return criterios;
  }
  criterioRemoved(event: any) {
    this.filterData.patchValue({
      [event.criterio]: null
    });
    if (event.criterio == 'anoConclusao') {
      this.filtersRange.anoConclusaoInicio = null;
      this.filtersRange.anoConclusaoFim = null;
      this.anoConclusaoInicio = null;
      this.anoConclusaoFim = null;
    }
    this.criterios = this.criterios.filter((c: any) => c !== event.criterio);
    this.getData();
  }

  filterStatusChanged(event: {}) {
    this.statusFilter = event;
    this.getData();
  }
  filterCustomChanged(event: {}) {
    this.customFilter = event;
    this.getData();
  }
  transitionStatusChanged(event: any): void {
    if (!event || !event.data || !event.data.contrato || !event.data.contrato.company) {
      console.warn('Evento inválido:', event);
      return;
    }

    this.statusTransition = event;
    const idEntidade = event.data.contrato.company.id;
    const idAmpliacao = event.data.id;
    const transicaoId = event.transicaoId;
    const statusAtualId = event.data.status?.statusAtual?.id;
    const transicaoNome = event.transicaoNome;
    this.idAmpliacao = idAmpliacao;
    this.idEntidade = idEntidade;
    this.transicaoId = transicaoId;
    this.statusAtualId = statusAtualId;

    switch (event.transicaoNome) {
      case 'Enviar comprovação':
        this.router.navigate([
          `documento-comprovacao/${'afericao-ampliacao'}/${idEntidade}/${idAmpliacao}/${transicaoId}/${statusAtualId}/${transicaoNome}`
        ]);
        break;

      case 'Encaminhar para análise':
        this.openAnalyzeDialog(idEntidade, transicaoNome);
        break;

      case 'Solicitar complementação':
        this.router.navigate([
          `documento-comprovacao/${'afericao-ampliacao'}/${idEntidade}/${idAmpliacao}/${transicaoId}/${statusAtualId}/${transicaoNome}`
        ]);
        break;

      case 'Atestar parâmetro':
        this.router.navigate([
          `documento-comprovacao/${'afericao-ampliacao'}/${idEntidade}/${idAmpliacao}/${transicaoId}/${statusAtualId}/${transicaoNome}`
        ]);
        break;

      default:
        console.warn('Ação de transição não reconhecida:', event);
        break;
    }
  }

  openAnalyzeDialog(idEntidade: string, transicaoNome: string): void {
    const dialogRef = this.dialog.open(AnalyzeDetailComponent, {
      width: '1350px',
      data: {
        protocolNumber: '010203040506070809',
        idEntidade: idEntidade,
        transicaoNome: transicaoNome,
        idAfericao: this.idAmpliacao,
        from: 'afericao-ampliacao'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.transitionStatusComplete(this.idAmpliacao, this.statusAtualId, this.transicaoId, result.data, result.idDocumentoComprovacao);
      }
    });
  }

  transitionStatusComplete(idAmpliacao: any, idStatusAtual: any, transicaoId: any, data?: any, idDocumentoComprovacao?: any,) {
    let analiseAfericao: any = [];

    const analisesAfericao = Array.from(data.entries());
    analisesAfericao.forEach(([protocolo, analise]: any) => {
      const itensSelecionados = analise.items
        .filter((item: any) => item.selected)
        .map((item: any) => ({
          idTipoAnalise: item.id,
          descricao: item.description,
          idUsuario: item.responsibleId,
          prazo: item.dueDate ? moment(item.dueDate).format('YYYY-MM-DD') : ''
        }));

      if (itensSelecionados.length > 0) {
        if (protocolo.includes('Gerando')) {
          analiseAfericao.push({
            itensAnalise: itensSelecionados
          });
        } else {
          analiseAfericao.push({
            idDocumentoComprovacao: idDocumentoComprovacao,
            itensAnalise: itensSelecionados
          });
        }
      }
    });

    const resultadoFinal = {
      analise: {
        analiseAfericao: analiseAfericao
      }
    };

    const transicaoStatusRequestData = {
      idExterno: idAmpliacao,
      idStatusAtual: idStatusAtual,
      idTransicao: transicaoId,
      analise: resultadoFinal.analise
    };
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(transicaoStatusRequestData)], { type: 'application/json' }));
    this.loadingService.showLoading();
    this.afericaoAmpliacaoService.postTransicaoStatus(formData).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe(
      (response: any) => {
        this.getData(0);
        this.toastService.showSuccess('Mudança de status realizada com sucesso');
      },
      (erro: any) => {
        if (erro.status !== 500 && erro.status) {
          this.toastService.showError(erro.error.message);
        } else {
          this.toastService.showError();
        }
      }
    );
  }

  transitionStatus(formData?: any): void {
    this.loadingService.showLoading();

    this.afericaoAmpliacaoService.postTransicaoStatus(formData)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: () => {
          this.getData(0);
          this.toastService.showSuccess('Mudança de status realizada com sucesso');
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        }
      });
  }
  private processRange(value: string, initialPropName: string, finalPropName: string): void {
    const parts = value.split(' - ').map(part => {
      // Remove os zeros à esquerda e converte para número
      const num = parseInt(part.replace(/^0+/, ''), 10);
      return isNaN(num) ? null : num;
    });

    let start: number | null = null;
    let end: number | null = null;

    if (parts.length === 2 && parts[0] !== null && parts[1] !== null) {
      if (parts[0] <= parts[1]) {
        start = parts[0];
        end = parts[1];
      } else {
        // Retorna para interromper a execução em caso de erro
        return;
      }
    } else if (parts.length === 1 && parts[0] !== null) {
      start = parts[0];
      end = null;
    } else {
      start = null;
      end = null;
    }

    // Atualiza as propriedades dinamicamente
    (this as any)[initialPropName] = start;
    (this as any)[finalPropName] = end;
  }
}
